import AcctMgmtRoute from './AcctMgmtRoute'
import AdminAcctMgmtRoute from "./AdminAcctMgmtRoute";

const routes = [
  new AcctMgmtRoute(),
  new AdminAcctMgmtRoute()
]

export default routes
